import { useEffect, useRef } from 'react';
import { useLocation } from 'react-router-dom';
import { NAV_OFFSET } from './constants';
import { scrollToSection } from './scroll-to-section';

export default function UpdateHashOnScroll() {
  const { hash } = useLocation();
  const hasMounted = useRef(false);

  // Use generic scrollToSection utility
  useEffect(() => {
    // On mount, skip first render
    if (!hasMounted.current) {
      hasMounted.current = true;
      return;
    }

    // React Router hash change
    if (hash) {
      scrollToSection(hash);
      const timeoutId = setTimeout(() => scrollToSection(hash), 300);
      return () => clearTimeout(timeoutId);
    }
  }, [hash]);

  // Listen for hashchange events (browser, e.g. clicking same anchor)
  useEffect(() => {
    const onHashChange = () => {
      scrollToSection(window.location.hash);
      setTimeout(() => scrollToSection(window.location.hash), 300);
    };
    window.addEventListener('hashchange', onHashChange);
    return () => window.removeEventListener('hashchange', onHashChange);
  }, []);

  // Update hash in URL as user scrolls, but don't trigger navigation
  // useEffect(() => {
  //   const handleIntersect = (entries) => {
  //     entries.forEach(entry => {
  //       if (entry.isIntersecting) {
  //         if (window.location.hash !== `#${entry.target.id}`) {
  //           window.history.replaceState(
  //             null,
  //             "",
  //             `#${entry.target.id}`
  //           );
  //         }
  //       }
  //     });
  //   };

  //   const observer = new window.IntersectionObserver(handleIntersect, {
  //     root: null,
  //     rootMargin: "0px",
  //     threshold: 0.5,
  //   });

  //   SECTION_IDS.forEach(id => {
  //     const el = document.getElementById(id);
  //     if (el) observer.observe(el);
  //   });

  //   return () => observer.disconnect();
  // }, []);

  return null;
}
